<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.feedback}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="product.title | safeHtml"></span>
	</h5>
</div>
<div class="modal-body">
	<div style="max-height:525px;overflow-y:auto;overflow-x:hidden;">
		<div class="col-sm-8 col-xs-12">
			<div>
				<h4>{{LOCALIZATION.comments}}</h4>
				<textarea class="comment" maxlength="1500" [(ngModel)]="comment" placeholder="Enter in your comments..."></textarea>
				<span class="help-block pull-right">{{comment.length}}/1500</span>
			</div>
			<!-- 
			<div>
                <label class="control control--checkbox">
                  <input type="checkbox" ng-model="isScreenshot" ng-click="createScreenshot()" ng-disabled="inprogress"/>
                  <div class="control__indicator"></div>
                  <p style="font-size:14px;font-weight:400;margin-left:5px" class="truncate" title="{{LOCALIZATION.screenshotInclude}}">{{LOCALIZATION.screenshotInclude}}</p>
                </label>
                
          	    <div ng-show="inprogress">
              	  <i class="fas fa-spinner fa-spin fa-fw"></i>
             	 {{LOCALIZATION.loading}}
                </div>                
                			
				<div class="feedback">
					<div class="feedbackBorder flex flex-1" ng-repeat="image in images track by $index">
						<img class="feedbackImage" alt="feedbackImage{{$index}}" ng-src="{{image.src}}" />
						<i class="fa fa-times fa-1x text-red pointMe pull-right cancelFeedback" aria-hidden="true" ng-click="removeImage($index)"></i>
					</div>
				</div>	
			</div>
			 -->
		</div>
		<div class="col-sm-4 hidden-xs">
			<h4>{{LOCALIZATION.metadata}}</h4>
			<div *ngFor='let key of Object.keys(metadata)' class="list-group-item hoverme">
				<h4 class="list-group-item-heading">{{key}}</h4>
				<div [hidden]="!metadata[key].links">
					<ul style="list-style:none; word-break:break-all;">
						<li *ngFor="let link of metadata[key].links">
							<span class="link disabled" title="{{link.href}}"> {{link.name}} </span>
						</li>
					</ul>
				</div>
				<p [hidden]="metadata[key]?.links" 
					class='dd-text-collapse' 
					[ngClass]="{'warning' : metadata[key].warning}" 
					ddTextCollapse
					[ddTextCollapseMaxLength]="metadata[key].maxLength" 
					[ddTextCollapseText]="metadata[key].value">
				</p>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
	<button class="btn btn-primary" type="button" (click)="submitFeedback()" [disabled]="submitting">
		<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!submitting"></i>
		{{LOCALIZATION.submit}}
	</button>
</div>